const PRELOAD_IMAGES = 3;

const SCROLL_DELAY = 300;

export { PRELOAD_IMAGES, SCROLL_DELAY };
